import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExportersProcesses(customer_id) {
    return RequesterV1.get(`customer/query/containers_intermediated/${customer_id}/fetch_agro_exporter_processes`);
  },
};
